import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PreviewPdfFile from '../../../components2/PreviewPdfFile';
import { filePreviewUrl, isWordFile } from '../../../utils/filePreview';
import PdfPagePreview from './PdfPagePreview';

// `pageIndex` (0-based) marks one page of a larger file: a response routed out
// of a multi-student upload. Then only that page is drawn, never the whole
// file (which holds other students' pages). Without it the file is the
// student's own and is shown whole, as before.
const PreviewFiles = ({ id, url, pageIndex = null }) => {
  const [isImageValid, setIsImageValid] = useState(null);
  const onePage = Number.isInteger(pageIndex);

  useEffect(() => {
    setIsImageValid(null);
    if (isWordFile(url) || /\.pdf(?:[?#]|$)/i.test(url || '')) {
      setIsImageValid(false);
      return;
    }
    const checkImgUrl = new window.Image();
    checkImgUrl.onload = () => setIsImageValid(true);
    checkImgUrl.onerror = () => setIsImageValid(false);
    checkImgUrl.src = filePreviewUrl(url);
    return () => { checkImgUrl.onload = null; checkImgUrl.onerror = null; };
  }, [url]);

  if (isImageValid == null) return <div role="status">Loading document preview…</div>;

  if (isImageValid) return <PreviewImg key={id} id={id} src={filePreviewUrl(url)} />;
  return onePage ? (
    <PdfPagePreview url={url} pageIndex={pageIndex} />
  ) : (
    <PreviewPdfFile url={url} />
  );
};

export default PreviewFiles;

export const PreviewImg = styled.img`
  width: 100%;
`;
